export default "__VITE_ASSET__7bfcab6d__"